// Prevents a method from being executed more than every miliseconds specified by delay
function throttle(fn, delay, ctx) {

    let lastTime = new Date().getTime();

    return function () {
        const now = new Date().getTime();

        ctx = ctx || this;

        if (now - lastTime > delay) {
            fn.call(ctx);
            lastTime = now;
        }
    };

};

// Prevents a method from being executed util miliseconds specified by delay have passed
// since it was last called
function debounce(fn, delay, ctx) {

    let timeout;

    return function () {

        const args = arguments;

        ctx = ctx || this;

        if (timeout) {
            clearTimeout(timeout);
        }

        timeout = setTimeout(function () {
            fn.apply(ctx, args);
        }, delay);
    };
};

// Runs the fn until the condition is true or maxCalls has been reached
function waitForIt(fn, condition, interval = 1000, maxCalls = Infinity, context) {

    context = context || this;

    let calls = 0;

    function testCondition() {
        if (calls < maxCalls && condition()) {
            fn.call(context);
        }
        else if (calls < maxCalls) {
            setTimeout(testCondition, interval);
        }
        calls++;
    }

    testCondition();

}

export { throttle, debounce, waitForIt };